module.exports = __webpack_public_path__ + "static/media/m1_sf_7.d76e4adc.png";